import { render, staticRenderFns } from "./Vision2.vue?vue&type=template&id=439d7f55&scoped=true&lang=html&"
import script from "./Vision2.vue?vue&type=script&lang=js&"
export * from "./Vision2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439d7f55",
  null
  
)

export default component.exports